import React, { useState } from 'react';
import Picture from '../../image/profile-picture.png';
import './about.css';
import useScrollReveal from '../../hooks/useScrollReveal';

function About() {
  const [copied, setCopied] = useState(false);
  const sectionRef = useScrollReveal();

  function copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    }).catch((err) => {
      console.error('Failed to copy text: ', err);
    });
  }

  const stats = [
    { value: '1+', label: 'Years Coding' },
    { value: '4+', label: 'Projects Built' },
    { value: '8+', label: 'Technologies' },
  ];

  return (
    <div className="About-section" id="About" ref={sectionRef}>
      <div className="About-title scroll-reveal">
        <i className="fas fa-user"></i>
        <h1>About <span>Me</span></h1>
      </div>
      <p className="section-subtitle scroll-reveal delay-1">
        Get to know who I am and what drives me
      </p>

      <div className="about-content">
        <div className="about-image-side scroll-reveal from-left">
          <div className="about-image-wrapper">
            <img src={Picture} alt="Dehili Mohammed" />
          </div>
        </div>

        <div className="about-text-side scroll-reveal from-right delay-1">
          <h2>
            I'm <span className="name">Mohammed</span>
          </h2>
          <h3 className="about-role">
            Full Stack Developer && Bug Bounty Hunter
          </h3>
<p className="about-bio">
  I'm a third-year cybersecurity student at 
  <span className="faculty"> Saad Dahleb University</span> and a junior web developer. 
  I'm learning ethical hacking and web security while building full-stack projects 
  using JavaScript, React, Python, and PHP. I also practice bug bounty hunting to 
  improve my practical security skills. My goal is to grow as both a developer and 
  a security researcher and help build secure web applications.
</p>

          <div className="about-contact">
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <div>
                <span className="contact-label">Email</span>
                <span
                  className="email-address"
                  onClick={() => copyToClipboard('mohadhl2005@gmail.com')}
                >
                  mohadhl2005@gmail.com
                </span>
                {copied && <span className="copied-message">Copied!</span>}
              </div>
            </div>
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <span className="contact-label">Location</span>
                <span className="address">Blida, Algeria</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="about-stats scroll-reveal delay-2">
        {stats.map((stat, index) => (
          <div className={`stat-card scroll-reveal delay-${index + 1}`} key={index}>
            <h3 className="stat-value">{stat.value}</h3>
            <p className="stat-label">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default About;